<template>
  <v-navigation-drawer
    v-if="enabled"
    v-model="$store.state.helpDrawer"
    app
    fixed
    right
    clipped
    hide-overlay
    width="350"
    class="rai-help"
  >
    <div
      class="ma-4"
    >
      <p class="text-h5">{{ $t('help.help')}}</p>

      <v-divider class="mb-4"/>

      <component :is="helpPage"></component>

      <section>
        <h6 class="text-h6">{{ $t('help.needHelp') }}</h6>
        <p><a href="mailto:support@argument-theory.com">{{ $t('help.contactSupport') }}</a></p>
      </section>
    </div>

  </v-navigation-drawer>
</template>

<script>
import helpService from '@/services/help.js'

export default {
  name: "HelpPanel",

  components: {
  },

  mixins: [ ],

  props: {

  },

  data () {
    return {
      path: ''
    }
  },

  computed: {
    enabled () {
      return helpService.isHelpEnabled(this.$route.path)
    },
    help() {
      return this.$store.state.helpPage
    },
    helpPage() {
      if(this.help && this.$i18n.locale) {
        return () => import('../help/' + this.help + '.' + this.$i18n.locale + '.vue')
      }
      return () => {}
    }
  },

  methods: {
  },

  created () {
  },
};
</script>

<style scoped>
.rai-help {
  z-index: 12;
}
</style>